/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@locus-taxy/neo-ui';

import { getLanguageFilterOptions } from 'common/constants/languageCodes';

type Props = {
    label: string,
    value: string,
    disabled?: ?boolean,
    onChange: (value: string) => void
};

const LanguageInput = ({
    label,
    value,
    onChange,
    disabled
}: Props): React.Node => {
    const { t } = useTranslation();

    const options = React.useMemo(() => {
        return getLanguageFilterOptions(t);
    }, [t]);

    return (
        <Select
            value={value}
            label={label}
            placeholder={label}
            onChange={option => onChange(option.value)}
            options={options}
            disabled={disabled}
            clearable={false}
            fullWidth
        />
    );
};

export default LanguageInput;
